import { initialPOState, IPOState } from '../state/po.state';
import { EPOActions, POAction } from '../actions/po.action';

export function poReducers(state = initialPOState, action: POAction):IPOState{
    switch(action.type){
//purchase orders
        case EPOActions.GetPONumberSuccess: {
            return {
                ...state,
                getPOIntCodeSuccess:action.payload,
                getPOIntCodeError: null
            };
        }
        case EPOActions.GetPONumberError: {
            return {
                ...state,
                getPOIntCodeError:action.payload,
                getPOIntCodeSuccess:null
            };
        }
        case EPOActions.GetAllPOsSuccess: {
            return {
                ...state,
                getAllPOSuccess:action.payload,
                getAllPOError: null
            };
        }
        case EPOActions.GetAllPOsError: {
            return {
                ...state,
                getAllPOError:action.payload,
                getAllPOSuccess:null
            };
        }
        case EPOActions.GetPOsByStatusIdSuccess: {
            return {
                ...state,
                getPosByStatusIdSuccess:action.payload,
                getPosByStatusIdError: null
            };
        }
        case EPOActions.GetPOsByStatusIdError: {
            return {
                ...state,
                getPosByStatusIdError:action.payload,
                getPosByStatusIdSuccess:null
            };
        }
        case EPOActions.GetAddPOSuccess: {
            return {
                ...state,
               getAddPOSuccess:action.payload,
               getAddPOError:null
            };
        }
        case EPOActions.GetAddPOError: {
            return {
                ...state,
               getAddPOError:action.payload,
               getAddPOSuccess:null
            };
        }
        case EPOActions.GetEditPOSuccess: {
            return {
                ...state,
               getEditPOSuccess:action.payload,
               getEditPOError:null
            };
        }
        case EPOActions.GetEditPOError: {
            return {
                ...state,
               getEditPOError:action.payload,
               getEditPOSuccess:null
            };
        }
        case EPOActions.GetPodetailsByIdSuccess: {
            return {
                ...state,
               getPodetailsByIdSuccess:action.payload,
               getPodetailsByIdError:null
            };
        }
        case EPOActions.GetPodetailsByIdError: {
            return {
                ...state,
               getPodetailsByIdError:action.payload,
               getPodetailsByIdSuccess:null
            };
        }
        case EPOActions.GetInActivatePOSuccess: {
            return {
                ...state,
                getInActivatePOSuccess:action.payload,
                getInActivatePOError:null
            };
        }
        case EPOActions.GetInActivatePOError: {
            return {
                ...state,
                getInActivatePOError:action.payload,
                getInActivatePOSuccess:null
            };
        }
        
        case EPOActions.GetReceiveMaterialCodeSuccess: {
            return {
                ...state,
              getReceiveMaterialCodeSuccess:action.payload,
              getReceiveMaterialCodeError:null
            };
        }
        case EPOActions.GetReceiveMaterialCodeError: {
            return {
                ...state,
                getReceiveMaterialCodeError:action.payload,
                getReceiveMaterialCodeSuccess:null
            };
        }
        case EPOActions.GetAddReceiveMaterialSuccess: {
            return {
                ...state,
              getAddReceiveMatSuccess:action.payload,
              getAddReceiveMatError:null
            };
        }
        case EPOActions.GetAddReceiveMaterialError: {
            return {
                ...state,
                getAddReceiveMatError:action.payload,
                getAddReceiveMatSuccess:null
            };
        }

        case EPOActions.GetAllReceivedLOTsSuccess: {
            return {
                ...state,
               getAllReceivedLOTsSuccess:action.payload,
               getAllReceivedLOTsError:null
            };
        }
        case EPOActions.GetAllReceivedLOTsError: {
            return {
                ...state,
                getAllReceivedLOTsError:action.payload,
                getAllReceivedLOTsSuccess:null
            };
        }
        case EPOActions.GetEditReceivedLOTsSuccess: {
            return {
                ...state,
               getEditReceivedLOTsSuccess:action.payload,
               getEditReceivedLOTsError:null
            };
        }
        case EPOActions.GetEditReceivedLOTsError: {
            return {
                ...state,
                getEditReceivedLOTsError:action.payload,
                getEditReceivedLOTsSuccess:null
            };
        }
        case EPOActions.GetVehicleConditionSuccess: {
            return {
                ...state,
               getVehicleConditionSuccess:action.payload,
               getVehicleConditionError:null
            };
        }
        case EPOActions.GetVehicleConditionError: {
            return {
                ...state,
                getVehicleConditionError:action.payload,
                getVehicleConditionSuccess:null
            };
        }
        case EPOActions.GetStatusMoveToCompleteSuccess: {
            return {
                ...state,
                getStatusMoveToCompleteSuccess:action.payload,
                getStatusMoveToCompleteError:null
            };
        }
        case EPOActions.GetStatusMoveToCompleteError: {
            return {
                ...state,
                getStatusMoveToCompleteError:action.payload,
                getStatusMoveToCompleteSuccess:null
            };
        }
        case EPOActions.GetCompletePOSuccess: {
            return {
                ...state,
                getCompletePOSuccess:action.payload,
                getCompletePOError:null
            };
        }
        case EPOActions.GetCompletePOError: {
            return {
                ...state,
                getCompletePOError:action.payload,
                getCompletePOSuccess:null
            };
        } case EPOActions.GetPOsByAgentManuIdSuccess: {
            return {
                ...state,
                getPOsByAgentManuIdSuccess:action.payload,
                getPOsByAgentManuIdError:null
            };
        } case EPOActions.GetPOsByAgentManuIdError: {
            return {
                ...state,
                getPOsByAgentManuIdError:action.payload,
                getPOsByAgentManuIdSuccess:null
            };
        }
        default: {   
            return state;
          }

     }

    
}